<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="商品销售汇总" name="goodsSalesSummary">
        <search-form-template
          :searchOptions="goodsSalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(1)"
        ></search-form-template>
        <table-template ref="goodsSalesSummary" :tableOptions="goodsSalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="类别销售汇总" name="categorySalesSummary">
        <search-form-template
          :searchOptions="categorySalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(2)"
        ></search-form-template>
        <table-template v-if="activeTab==='categorySalesSummary'" ref="categorySalesSummary"
                        :tableOptions="categorySalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="品牌销售汇总" name="brandSalesSummary">
        <search-form-template
          :searchOptions="brandSalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(3)"
        ></search-form-template>
        <table-template v-if="activeTab==='brandSalesSummary'" ref="brandSalesSummary"
                        :tableOptions="brandSalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="供应商销售汇总" name="supplierSalesSummary">
        <search-form-template
          :searchOptions="supplierSalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(4)"
        ></search-form-template>
        <table-template v-if="activeTab==='supplierSalesSummary'" ref="supplierSalesSummary"
                        :tableOptions="supplierSalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="日销售汇总" name="daySalesSummary">
        <search-form-template
          :searchOptions="daySalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(5)"
        ></search-form-template>
        <table-template v-if="activeTab==='daySalesSummary'" ref="daySalesSummary"
                        :tableOptions="daySalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="月销售汇总" name="monthSalesSummary">
        <search-form-template
          :searchOptions="monthSalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(6)"
        ></search-form-template>
        <table-template v-if="activeTab==='monthSalesSummary'" ref="monthSalesSummary"
                        :tableOptions="monthSalesSummaryTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="分店销售汇总" name="storeSalesSummary">
        <search-form-template
          :searchOptions="storeSalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(7)"
        ></search-form-template>
        <table-template
          v-if="activeTab==='storeSalesSummary'"
          ref="storeSalesSummary"
          :tableOptions="storeSalesSummaryTable"
        ></table-template>
      </el-tab-pane>
      <el-tab-pane label="分店销售日汇总" name="storeDaySalesSummary">
        <search-form-template
          :searchOptions="storeDaySalesSummarySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel(8)"
        ></search-form-template>
        <table-template v-if="activeTab==='storeDaySalesSummary'" ref="storeDaySalesSummary"
                        :tableOptions="storeDaySalesSummaryTable"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from "@/components/template/tableTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  name: "RoleManager",
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: "goodsSalesSummary",
      loading: false,
      treeConfig: {
        id: "menuTree",
        showCheckbox: true,
        data: [],
        nodeKey: "id",
        defaultProps: {
          children: "children",
          label: "name",
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ""},
        },
      },

      // 更多功能
      toolConfig: [
        {
          label: "打印",
          code: "print",
        },
        {
          label: "导出",
          code: "export",
          callback: this.exportExcel
        },
      ],

      // 商品销售汇总
      goodsSalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "goodsName",
            isFuzzy: true,
            placeholder: "请输入商品名称/条码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            isHasAll: true,
            span: 8,
            change: this.getBrandSupplierChange,
            url: api.system.seStore,
          },
          {
            label: "品牌",
            type: "select",
            prop: "goodsBrandId",
            data: [],
            span: 8,
            //url: api.archives.brand,
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 8,
            //url: api.archives.supplier,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 8,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
          // {
          //   label: "是否赠送商品",
          //   type: "select",
          //   prop: "giveGoodsType",
          //   data: this.$utils.getCacheStatus('soBillOrderGoodsMap.giveGoodsType'),
          //   span: 8,
          // },

        ],
      },
      // 类别
      categorySalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "goodsCategoryName",
            isFuzzy: true,
            placeholder: "请输入类别名称/编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            isHasAll: true,
            span: 8,
            url: api.system.seStore,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',//多选
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 8,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
        ],
      },
      // 品牌
      brandSalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "brandName",
            isFuzzy: true,
            placeholder: "请输入品牌名称/编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            isHasAll: true,
            span: 8,
            change: this.getBrandChange,
            url: api.system.seStore,
          },
          {
            label: "品牌",
            type: "select",
            prop: "goodsBrandId",
            data: [],
            span: 8,
            //url: api.archives.brand,
          },
        ],
      },
      // 供应商
      supplierSalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "supplierName",
            isFuzzy: true,
            placeholder: "请输入供应商名称/编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            isHasAll: true,
            change: this.getSupplierChange,
            url: api.system.seStore,
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 8,
            //url: api.archives.supplier,
          },
        ],
      },
      // 商品 日
      daySalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "goodsName",
            isFuzzy: true,
            placeholder: "请输入商品名称/条码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 6,
            isHasAll: true,
            change: this.getBrandSupplierChange,
            url: api.system.seStore,
          },
          {
            label: "品牌",
            type: "select",
            prop: "goodsBrandId",
            data: [],
            span: 6,
            //url: api.archives.brand,
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 6,
            //url: api.archives.supplier,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
        ],
      },
      // 商品 月
      monthSalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "goodsName",
            isFuzzy: true,
            placeholder: "请输入商品名称/条码",
          },
        ],
        complex: [
          // {
          //   label: "选择日期",
          //   prop: "CreateDttm",
          //   type: "dateTimeRangeButton",
          //   dateType: "datetime",
          //   span: 24,
          // },
          {
            label: '选择月份',
            prop: 'CreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            change: this.monthChange,
            span: 24
          },
          {
            label: '选择月份',
            prop: 'edCreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            span: 8,
            hidden: true
          },
          {
            label: '选择月份',
            prop: 'stCreateDttm',
            type: 'dateMonthPicker',
            dateType: 'month',
            span: 8,
            hidden: true
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 6,
            isHasAll: true,
            change: this.getBrandSupplierChange,
            url: api.system.seStore,
          },
          {
            label: "品牌",
            type: "select",
            prop: "goodsBrandId",
            data: [],
            span: 6,
            //url: api.archives.brand,
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 6,
            //url: api.archives.supplier,
          },
          {
            label: "类别",
            type: 'cascaderMultiple',
            prop: 'goodsCategoryIds',
            valueKey: 'value',
            data: [],
            span: 6,
            change: this.typeChange,
            url: api.archives.getCategoryTree,
          },
        ],
      },
      // 门店
      storeSalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "storeName",
            isFuzzy: true,
            placeholder: "请输入门店名称/编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 8,
            isHasAll: true,
            url: api.system.seStore,
          },
        ],
      },
      // 门店 日
      storeDaySalesSummarySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "storeName",
            isFuzzy: true,
            placeholder: "请输入门店名称/编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 8,
            isHasAll: true,
            url: api.system.seStore,
          },
        ],
      },

      // 商品
      goodsSalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "150",
            align: "center",
          },
          {
            label: "条码",
            prop: "barCode",
            width: "150",
            align: "center",
          },
          {
            label: "商品名称",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "70",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "70",
            align: "center",
          },
          {
            label: "类别",
            prop: "goodsCategoryName",
            width: "100",
            align: "center",
          },
          {
            label: "品牌",
            prop: "brandName",
            width: "150",
            align: "center",
          },
          {
            label: "供应商",
            prop: "supplierName",
            width: "150",
            align: "center",
          },
          {
            label: "原零售价",
            prop: "retailPrice",
            width: "100",
            align: "center",
          },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售均价",
            prop: "avgMoney",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        // url: api.retail.goodsSalesSummary,
      },
      // 类别
      categorySalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "类别名称",
            prop: "goodsCategoryName",
            width: "100",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "销售均价",
          //   prop: "avgMoney",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.categorySalesSummary,
      },
      // 品牌
      brandSalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "品牌名称",
            prop: "brandName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "销售均价",
          //   prop: "avgMoney",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.brandSalesSummary,
      },
      // 供应商
      supplierSalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引

        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "供应商名称",
            prop: "supplierName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "销售均价",
          //   prop: "avgMoney",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            // deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.supplierSalesSummary,
      },
      // 商品 日
      daySalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "日期",
            prop: "dayDate",
            width: "100",
            align: "center",
          },
          {
            label: "条码",
            prop: "barCode",
            width: "150",
            align: "center",
          },
          {
            label: "商品名称",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "70",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "70",
            align: "center",
          },
          {
            label: "类别",
            prop: "goodsCategoryName",
            width: "100",
            align: "center",
          },
          {
            label: "品牌",
            prop: "brandName",
            width: "150",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售均价",
            prop: "avgMoney",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.daySalesSummary,
      },
      // 商品 月
      monthSalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "月份",
            prop: "dayDate",
            width: "100",
            align: "center",
          },
          {
            label: "商品名称",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "条码",
            prop: "barCode",
            width: "150",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "70",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "70",
            align: "center",
          },
          {
            label: "类别",
            prop: "goodsCategoryName",
            width: "100",
            align: "center",
          },
          {
            label: "品牌",
            prop: "brandName",
            width: "100",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售均价",
            prop: "avgMoney",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        url: api.retail.monthSalesSummary,
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
      },
      // 门店
      storeSalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "销售均价",
          //   prop: "avgMoney",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.storeSalesSummary,
      },
      // 门店 日
      storeDaySalesSummaryTable: {
        showSummary: true,
        summaryColumns: ['goodsNum', 'payPrice', 'refundNum', 'refundPrice', 'giveNum', 'givePrice', 'totalMoney', 'subTotalNum'],
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "190",
            align: "center",
          },
          // {
          //   label: "门店编码",
          //   prop: "storeCode",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "日期",
            prop: "dayDate",
            width: "150",
            align: "center",
          },
          // {
          //   label: "原零售价",
          //   prop: "retailPrice",
          //   width: "100",
          //   align: "center",
          // },
          // {
          //   label: "销售均价",
          //   prop: "avgMoney",
          //   width: "100",
          //   align: "center",
          // },
          {
            label: "销售数量",
            prop: "goodsNum",
            width: "100",
            align: "center",
          },
          {
            label: "销售金额",
            prop: "payPrice",
            width: "100",
            align: "center",
          },
          {
            label: "退货数量",
            prop: "refundNum",
            width: "100",
            align: "center",
          },
          {
            label: "退货金额",
            prop: "refundPrice",
            width: "100",
            align: "center",
          },
          {
            label: "赠送数量",
            prop: "giveNum",
            width: "100",
            align: "center",
          },
          {
            label: "赠送金额",
            prop: "givePrice",
            width: "100",
            align: "center",
          },
          {
            label: "数量小计",
            width: "100",
            prop: "subTotalNum",
            align: "center",
            //deal: this.sumNum,
          },
          {
            label: "金额小计",
            prop: "totalMoney",
            width: "100",
            align: "center",
          },
        ],
        param: {
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        },
        url: api.retail.storeDaySalesSummary,
      },
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.goodsSalesSummarySearchOptions.complex);
    this.setStore(this.categorySalesSummarySearchOptions.complex);
    this.setStore(this.brandSalesSummarySearchOptions.complex);
    this.setStore(this.supplierSalesSummarySearchOptions.complex);
    this.setStore(this.daySalesSummarySearchOptions.complex);
    this.setStore(this.monthSalesSummarySearchOptions.complex);
    this.setStore(this.storeSalesSummarySearchOptions.complex);
    this.setStore(this.storeDaySalesSummarySearchOptions.complex);
    this.getBrandSupplier();
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 0 && this.$route.params.code === '2') {
      this.goodsSalesSummaryTable.param = this.$route.params.timeParam
    }
    this.$nextTick(() => {
      if (this.activeTab === 'goodsSalesSummary') {
        this.goodsSalesSummaryTable.url = api.retail.goodsSalesSummary
        this.$refs['goodsSalesSummary'].operationSuccess();
      }
    })
  },
  methods: {
    // 获取某个月的总天数
    getDaysOfMonth(year, month) {
      let date = new Date(year, month, 0);
      let days = date.getDate();
      return days;
    },
    // 选择月份
    monthChange(val) {
      let year = ''
      let month = ''
      if (val && val.CreateDttm) {
        year = val.CreateDttm.split('-')[0]
        month = val.CreateDttm.split('-')[1]
        val.stCreateDttm = val.CreateDttm + '-01' + ' ' + '00:00:00'
        val.edCreateDttm = val.CreateDttm + '-' + this.getDaysOfMonth(year, month) + ' ' + '23:59:59'
      } else {
        val.stCreateDttm = null
        val.edCreateDttm = null
      }
    },
    // 数量小计
    sumNum(row) {
      return `<span>${(Number(row.goodsNum) + Number(row.refundNum) + Number(row.giveNum)).toFixed(3)}</span>`;
    },
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    tabChange() {
      // this.$refs[this.activeTab].operationSuccess();
    },
    clearSearch() {
      this.$refs['goodsSalesSummary'].clearSearch();
      this.$refs['categorySalesSummary'].clearSearch();
      this.$refs['brandSalesSummary'].clearSearch();
      this.$refs['supplierSalesSummary'].clearSearch();
      this.$refs['daySalesSummary'].clearSearch();
      this.$refs['monthSalesSummary'].clearSearch();
      this.$refs['storeSalesSummary'].clearSearch();
      this.$refs['storeDaySalesSummary'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
        this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.brandSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = [];
        this.supplierSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
      }
    },
    getBrandSupplier() {
      let userInfo = this.$utils.getSysUser();
      if (userInfo.storeId) {
        this.$axios.fetchPost(api.archives.brand + '/list', {}).then(data => {
          if (data.code === 200) {
            this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            this.brandSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.archives.supplier + '/list', {}).then(data => {
          if (data.code === 200) {
            this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            this.supplierSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      }
    },
    getBrandSupplierChange(form) {
      form.goodsBrandId = '';
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;

        }
      });
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.goodsSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          this.daySalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          this.monthSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      })
    },
    getBrandChange(form) {
      form.goodsBrandId = '';
      this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.brandSalesSummarySearchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
        }
      });
    },
    getSupplierChange(form) {
      form.supplierId = '';
      this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.supplierSalesSummarySearchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
        }
      });
    },
    exportExcel(param) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let params, url, fileName;
      if (param === 1) {
        params = this.$refs["goodsSalesSummary"].searchParam;
        url = api.retail.goodsSalesSummaryExport;
        fileName = '商品销售汇总_';
      } else if (param === 2) {
        params = this.$refs["categorySalesSummary"].searchParam;
        url = api.retail.categorySalesSummaryExport;
        fileName = '类别销售汇总_';
      } else if (param === 3) {
        params = this.$refs["brandSalesSummary"].searchParam;
        url = api.retail.brandSalesSummaryExport;
        fileName = '品牌销售汇总_';
      } else if (param === 4) {
        params = this.$refs["supplierSalesSummary"].searchParam;
        url = api.retail.supplierSalesSummaryExport;
        fileName = '供应商销售汇总_';
      } else if (param === 5) {
        params = this.$refs["daySalesSummary"].searchParam;
        url = api.retail.daySalesSummaryExport;
        fileName = '日销售汇总_';
      } else if (param === 6) {
        params = this.$refs["monthSalesSummary"].searchParam;
        url = api.retail.monthSalesSummaryExport;
        fileName = '月销售销售汇总_';
      } else if (param === 7) {
        params = this.$refs["storeSalesSummary"].searchParam;
        url = api.retail.storeSalesSummaryExport;
        fileName = '分店销售汇总_';
      } else if (param === 8) {
        params = this.$refs["storeDaySalesSummary"].searchParam;
        url = api.retail.storeDaySalesSummaryExport;
        fileName = '分店销售日汇总_';
      }
      this.$axios.PostBlob(url, params).then(res => {
        if (res.status === 200) {
          fileName = fileName + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.warning("当前导出数据为空或超出10000条。");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
  },
};
</script>

<style scoped>
.page-template {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/page/retail/query/sales/Summary.vue